import { render, staticRenderFns } from "./SubCompaniesListTable.vue?vue&type=template&id=84263624&scoped=true&"
import script from "./SubCompaniesListTable.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SubCompaniesListTable.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SubCompaniesListTable.vue?vue&type=style&index=0&id=84263624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84263624",
  null
  
)

export default component.exports